import io from "socket.io-client";
const URL = process.env.REACT_APP_Endpoint;

let socket;

if (process.env.REACT_APP_Socket === 'true') {
    socket = io(URL);
}

export default socket;